import Subtitles from "@material-symbols/svg-500/rounded/subtitles.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

export const EditorSubtitlesIcon = memo((props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Subtitles });
	return <Icon />;
});
